import React from 'react';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ReactHookFormIntlNumberInputConsumption } from 'common/components/form';

import { ENERGY_CONCEPTS_CONFIG } from '../../constants';

const EnergyField = ({ concept, control, disabled, error, name, onBlur }) => {
    const { t } = useTranslation();
    let icon = null;
    if (error === true) {
        icon = <ReportProblemIcon color="error" />;
    } else if (error === false) {
        icon = <CheckCircleIcon color="success" />;
    }

    return (
        <Grid size={{ md: 'grow', xs: 18 }}>
            <ReactHookFormIntlNumberInputConsumption
                allowDecimals={false}
                append="kWh"
                control={control}
                disabled={disabled}
                fullWidth
                label={t(ENERGY_CONCEPTS_CONFIG[concept]?.label)}
                name={`${name}.${concept}`}
                onBlur={onBlur}
                prepend={icon}
                variant="standard"
            />
        </Grid>
    );
};

EnergyField.propTypes = {
    concept: PropTypes.string,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    name: PropTypes.string,
    onBlur: PropTypes.func,
};

export default EnergyField;
